import './index.css'
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

document.addEventListener('DOMContentLoaded', () => {
    // one instance handles all video links
    GLightbox({
        selector: '.js-video-lightbox',
        autoplayVideos: true,
        touchNavigation: true,
        // optional:
        // videosWidth: '960px',
        // plyr: { css: '', js: '' } // only if you integrate Plyr yourself
    });
});